export const CONTROL = 'control';
export const MEMBERSHIP_OPTIONS_EXPERIMENT = 'jf-membership-options';

export const DIRECT_TO_CHECKOUT_TRIALS = 'direct-to-checkout-trials';
export const DIRECT_TO_CHECKOUT_PAID = 'direct-to-checkout-paid';

// PayPal V2 Experiments
export const EXPERIMENT_JF_PAYPAL_V2_EU = 'experiment-jf-paypal-v2-eu';
export const EXPERIMENT_JF_PAYPAL_V2_UK = 'experiment-jf-paypal-v2-uk';
export const EXPERIMENT_JF_PAYPAL_V2_ANZ = 'experiment-jf-paypal-v2-anz';
export const EXPERIMENT_JF_NO_MTM = 'mtm-removal';

export const EXPERIMENT_SIMPLIFIED_MEMBERSHIP =
  'experiment-simplified-membership-v2';

export const simplifiedMembershipVariant = 'experiment';

// Band Selector Experiment
export const JF_BAND_SELECTOR = 'experiment-jf-band-select-v4';
export const BAND_SELECTOR_NO_CONTENT = 'band-select-no-content';
export const BAND_SELECTOR_CONTENT = 'band-select-content';

// Band Selector Experiment
export const JF_BAND_SELECTOR_HEADER = 'experiment-jf-band-select-header-v2';
export const NON_STICKY_BAND_SELECTOR = 'experiment-single-non-sticky';
export const EXPERIMENT_GCC_TRIAL_DEPOSIT = 'experiment-gcc-trial-deposit-v3';
export const JF_CART_TOTALS = 'experiment-jf-cart-totals';
export const JF_VERTICAL_STACK = 'experiment-jf-vertical-stack';
export const EXPERIMENT_JF_HIDE_PAGINATION = 'experiment-jf-hide-pagination';

// RAF Persistence Experiment
export const EXPERIMENT_JF_RAF_PERSISTENCE = 'experiment-jf-raf-persistence-v2';
export const RAF_PERSISTENCE_VARIANT = 'raf-persistence';
export const RAF_PERSISTENCE_CONTROL = 'control';

// Upgrade Card Copy Experiment
export const EXPERIMENT_UPGRADE_CARD_COPY = 'experiment-uf-card-copy';
export const upgradeCopyRenewVariant = 'experiment';
export const upgradeCopyControlVariant = 'control';

// Upcycle Membership Copy Experiment
export const EXPERIMENT_UPCYCLE_MEMBERSHIP_COPY =
  'experiment-upcycle-membership-copy';

export const upcycleCardCopyExperiment = 'upcycle-card-copy-experiment';
export const upcycleCardCopyControl = 'control';
export const EXPERIMENT_UPCYCLE_MODAL_ADD_GIFT_KIT =
  'upcycle-modal-add-gift-kit';

export const prepKitAmplitudeVariantName = 'automatic 2mo reminder';
export const prepKitAmplitudeControlName = 'control';

// Trial Block Experiment
export const EXPERIMENT_JF_TRIAL_BLOCK = 'experiment-jf-trial-block';
export const TRIAL_BLOCK_VARIANT = 'new-trial-block';
export const TRIAL_BLOCK_CONTROL = 'control';

// Cart Items Experiment
export const EXPERIMENT_JF_CART_ITEMS = 'experiment-jf-cart-items';
export const CART_ITEMS_VARIANT_ONLY_BAND = 'only-device';
export const CART_ITEMS_VARIANT_BAND_AND_WARRANTY = 'device-and-warranty';

// Truemed Payments Experiment
export const EXPERIMENT_TRUEDMED_PAYMENTS = 'exp-truemed-payments-v2';
